import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import FlatList from 'flatlist-react';
// import { render } from 'react-dom';
// import Spinner from 'react-activity/lib/Spinner';
// import 'react-activity/lib/Spinner/Spinner.css';
import Spinner from 'react-activity/dist/Spinner';
// import socketIOClient from "socket.io-client";
import baseApi from '../../../baseApiUrl';

export default class WaitingRoomButton extends React.Component {
    
    // accessibilityLabel = 'toolbar.accessibilityLabel.Settings';
    // icon = IconSettings;
    // label = 'toolbar.Settings';
    // tooltip = 'toolbar.Settings';

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            listedRooms: [],
            meetingId: window.location.pathname.substring(1),
            memberId: window.memberId,
            // socket: socketIOClient('https://abvideo.uc.r.appspot.com/', {transports: ['polling']}),
            fetchEndpoint: `${baseApi}/`,
            membersInterval: null,
            loading: false
        };
    }

    async pollForMembers() {
        console.log("Polling for members...");
        var res = await fetch(this.state.fetchEndpoint + 'api/internal/prelist_room', {
            method: "POST",
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "meeting_id": this.state.meetingId,
                "doctor_id": this.state.memberId
            })
        }).then(res => res.json()).then((res) => {return res});
        console.log("Result here", res);
        if(res['user_type'] == "doctor") {
            this.setState({
                listedRooms: res['members']
            })
        }
    }

    async componentDidMount() {
        var membersInterval = setInterval(this.pollForMembers.bind(this), 1000);
        // history.back();
        this.setState({membersInterval: membersInterval});
        // var res = await fetch(this.state.fetchEndpoint + 'api/internal/prelist_room', {
        //     method: "POST",
        //     mode: "cors",
        //     cache: 'no-cache',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify({
        //         "meeting_id": this.state.meetingId,
        //         "doctor_id": this.state.memberId
        //     })
        // }).then(res => res.json()).then((res) => {return res});
        // console.log(this.state.meetingId, this.state.memberId);
        // console.log(res, res['members'], "josh is a OG");
        // this.state.socket.emit('list_room', {
        //     "meeting_id": this.state.meetingId,
        //     "doctor_id": this.state.memberId,
        //     "members": res['members'],
        //     "user_type": res['user_type']
        // });
        
        // var boundUpdatedListRoomsFunction = this._updatedListRooms.bind(this);

        // this.state.socket.on('listed_rooms', boundUpdatedListRoomsFunction);
    }

    componentWillUnmount() {
        // this.state.socket.off('listed_rooms')
        clearInterval(this.state.membersInterval);
    }

    _updatedListRooms(message) {
        console.log(message, "testing update list rooms function");
        let members = message['members'];
        this.setState({
            listedRooms: members
        });
        //this.setState({loading: false})
    }
    
    onOpen() {
        this.setState({open: true});
    }

    onClose() {
        this.setState({open: false});
    }

    async onAccept(member_id) {
        console.log(this.state.meetingId, member_id);
        this.setState({loading: true})
        var res = await fetch(this.state.fetchEndpoint + 'api/internal/preadmit', {
            method: "POST",
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "meeting_id": this.state.meetingId,
                "doctor_id": this.state.memberId,
                "member_id": member_id,
                "admission": true
            })
        }).then(res => res.json()).then((res) => {return res});
        this.setState({listedRooms: this.state.listedRooms.filter(person => person.member_id != member_id)})
        //console.log(this.state.listedRooms);
        this.setState({loading: false})
        // this.state.socket.emit('admit', {
        //     "meeting_id": this.state.meetingId,
        //     "member_id": member_id,
        //     "doctor_id": this.state.memberId,
        //     "admission": true,
        //     "members": res['members'],
        //     "waiting_hash": res['waiting_hash']
        // });
    }

    async onDeny(member_id) {
        console.log(this.state.meetingId, member_id);
        this.setState({loading: true})
        var res = await fetch(this.state.fetchEndpoint + 'api/internal/preadmit', {
            method: "POST",
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "meeting_id": this.state.meetingId,
                "doctor_id": this.state.memberId,
                "member_id": member_id,
                "admission": false
            })
        }).then(res => res.json()).then((res) => {return res});
        this.setState({listedRooms: this.state.listedRooms.filter(person => person.member_id != member_id)})
        this.setState({loading: false})
        // this.state.socket.emit('admit', {
        //     "meeting_id": this.state.meetingId,
        //     "member_id": member_id,
        //     "doctor_id": this.state.memberId,
        //     "admission": false,
        //     "members": res['members'],
        //     "waiting_hash": null
        // });
    }

    renderParticipant = (participant) =>  {
        return (
            <div style={{display: "flex", flexDirection: "row", marginBottom: "20px"}}>
                <div style={{display: "flex", justifyContent: "center", alignItems: "center", fontSize: "15pt"}}>
                    <b>{participant.name}: </b>
                </div>
                <div style={{marginRight: "10px", marginLeft: "10px"}}>
                    <Button variant="contained" color="primary" onClick={() => {this.onAccept(participant.member_id);}} style={{zIndex: 10000000000}}>
                        Accept
                    </Button>
                </div>
                <div> 
                    <Button variant="contained" color="secondary" onClick={() => {this.onDeny(participant.member_id)}} style={{zIndex: 10000000000}}>
                        Deny
                    </Button>
                </div>
            </div>
        );
    }

    render() {

        const title = {
            fontSize: "30px",
            padding: "1px"
        }

        return (
            <div>
                {/* <div onClick = {this.onOpen.bind(this)}>
                    <IconBlurBackground/>
                </div> */}
                {
                    this.state.listedRooms.length > 0 ? <Button variant="outlined" color="primary" onClick={this.onOpen.bind(this)} style={{zIndex: 10000000000, backgroundColor: "white", top: '-7px'}}>
                                                            Waiting Room
                                                            <span className = 'badge-round'>
                                                                <span>
                                                                    { this.state.listedRooms.length || null }
                                                                </span>
                                                            </span>
                                                        </Button> 
                                                        : <Button variant="outlined" color="primary" onClick={this.onOpen.bind(this)} style={{zIndex: 10000000000, backgroundColor: "white", top: '-7px'}}>
                                                            Waiting Room
                                                        </Button>
                }
                <Dialog open = {this.state.open} onClose={this.onClose.bind(this)} aria-labelledby="max-width-dialog-title" maxWidth= "xl">
                    <DialogTitle id="dialog-title">
                        <p style = {title}>Waiting Room Queue</p>
                        {/* {open ? (
                            <IconButton aria-label="Close" onClick={this.onClose.bind(this)} style ={{alignSelf: 'flex-end'}}>
                            <CloseIcon />
                            </IconButton> ) : null} */}
                        </DialogTitle>
                    {!this.state.loading ? <DialogContent>
                            <FlatList
                                list = {this.state.listedRooms}
                                renderItem={this.renderParticipant}
                            />
                        </DialogContent>
                        :
                        <DialogContent>
                            <div style = {{display: 'flex', height: '50%', justifyContent:'center', alignItems:'center'}}>
                                <Spinner/>
                            </div>
                        </DialogContent> }
                </Dialog>
            </div>
        )
    }
}